import { AuroraModel } from '../enums'
import { Aurora } from '../types'
import { checkIsAuroraBackup } from '../utils/aurora'

export interface AuroraBackdropProps {
  aurora?: Aurora
  opacity?: number
}

export default function AuroraBackdrop({ aurora, opacity = 0.2 }: AuroraBackdropProps) {
  /**
   * Indicates if the aurora is backup power unit.
   */
  const isBackupPowerUnit = aurora ? checkIsAuroraBackup(aurora) : false

  const image = isBackupPowerUnit
    ? '/static/aurora/aurora_backup.jpeg'
    : '/static/aurora/aurora_awhp.jpeg'

  return (
    <img
      src={image}
      draggable={false}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        opacity: opacity,
        zIndex: 0
      }}
    />
  )
}
